import { render, staticRenderFns } from "./FrameCheckEsecuzioneDossier.vue?vue&type=template&id=a5b528e2&scoped=true&"
import script from "./FrameCheckEsecuzioneDossier.vue?vue&type=script&lang=js&"
export * from "./FrameCheckEsecuzioneDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b528e2",
  null
  
)

export default component.exports